/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { DataSourceLoadOptionsBase } from '../models/data-source-load-options-base';
import { LoadResult } from '../models/load-result';
import { TypeDechetRwdto } from '../models/type-dechet-rwdto';


/**
 * Gestion des types de déchets RW
 */
@Injectable({
  providedIn: 'root',
})
export class TypesDechetsRwService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation typeDechetRwGetList
   */
  static readonly TypeDechetRwGetListPath = '/api/types-dechets-rw/list';

  /**
   * Renvoie la liste des types de déchets RW.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `typeDechetRwGetList()` instead.
   *
   * This method doesn't expect any request body.
   */
  typeDechetRwGetList$Response(params?: {
  }): Observable<StrictHttpResponse<Array<TypeDechetRwdto>>> {

    const rb = new RequestBuilder(this.rootUrl, TypesDechetsRwService.TypeDechetRwGetListPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<TypeDechetRwdto>>;
      })
    );
  }

  /**
   * Renvoie la liste des types de déchets RW.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `typeDechetRwGetList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  typeDechetRwGetList(params?: {
  }): Observable<Array<TypeDechetRwdto>> {

    return this.typeDechetRwGetList$Response(params).pipe(
      map((r: StrictHttpResponse<Array<TypeDechetRwdto>>) => r.body as Array<TypeDechetRwdto>)
    );
  }

  /**
   * Path part for operation typeDechetRwLoadList
   */
  static readonly TypeDechetRwLoadListPath = '/api/types-dechets-rw/load-list';

  /**
   * Renvoie la liste des types de déchets RW (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `typeDechetRwLoadList()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  typeDechetRwLoadList$Response(params: {

    /**
     * Identifiant du parc
     */
    parcId?: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<StrictHttpResponse<LoadResult>> {

    const rb = new RequestBuilder(this.rootUrl, TypesDechetsRwService.TypeDechetRwLoadListPath, 'post');
    if (params) {
      rb.query('parcId', params.parcId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<LoadResult>;
      })
    );
  }

  /**
   * Renvoie la liste des types de déchets RW (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `typeDechetRwLoadList$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  typeDechetRwLoadList(params: {

    /**
     * Identifiant du parc
     */
    parcId?: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<LoadResult> {

    return this.typeDechetRwLoadList$Response(params).pipe(
      map((r: StrictHttpResponse<LoadResult>) => r.body as LoadResult)
    );
  }

  /**
   * Path part for operation typeDechetRwGet
   */
  static readonly TypeDechetRwGetPath = '/api/types-dechets-rw/{id}';

  /**
   * Renvoie le type de déchets RW.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `typeDechetRwGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  typeDechetRwGet$Response(params: {

    /**
     * Identifiant du type de déchets RW
     */
    id: number;
  }): Observable<StrictHttpResponse<TypeDechetRwdto>> {

    const rb = new RequestBuilder(this.rootUrl, TypesDechetsRwService.TypeDechetRwGetPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<TypeDechetRwdto>;
      })
    );
  }

  /**
   * Renvoie le type de déchets RW.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `typeDechetRwGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  typeDechetRwGet(params: {

    /**
     * Identifiant du type de déchets RW
     */
    id: number;
  }): Observable<TypeDechetRwdto> {

    return this.typeDechetRwGet$Response(params).pipe(
      map((r: StrictHttpResponse<TypeDechetRwdto>) => r.body as TypeDechetRwdto)
    );
  }

  /**
   * Path part for operation typeDechetRwPut
   */
  static readonly TypeDechetRwPutPath = '/api/types-dechets-rw/{id}';

  /**
   * Met à jour le type de déchets RW spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `typeDechetRwPut()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  typeDechetRwPut$Response(params: {

    /**
     * Identifiant du type de déchets RW à mettre à jour
     */
    id: number;

    /**
     * Type de déchets RW
     */
    body: TypeDechetRwdto
  }): Observable<StrictHttpResponse<TypeDechetRwdto>> {

    const rb = new RequestBuilder(this.rootUrl, TypesDechetsRwService.TypeDechetRwPutPath, 'put');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<TypeDechetRwdto>;
      })
    );
  }

  /**
   * Met à jour le type de déchets RW spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `typeDechetRwPut$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  typeDechetRwPut(params: {

    /**
     * Identifiant du type de déchets RW à mettre à jour
     */
    id: number;

    /**
     * Type de déchets RW
     */
    body: TypeDechetRwdto
  }): Observable<TypeDechetRwdto> {

    return this.typeDechetRwPut$Response(params).pipe(
      map((r: StrictHttpResponse<TypeDechetRwdto>) => r.body as TypeDechetRwdto)
    );
  }

  /**
   * Path part for operation typeDechetRwDelete
   */
  static readonly TypeDechetRwDeletePath = '/api/types-dechets-rw/{id}';

  /**
   * Supprime le type de déchets RW spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `typeDechetRwDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  typeDechetRwDelete$Response(params: {

    /**
     * Identifiant du type de déchets RW à supprimer
     */
    id: number;
  }): Observable<StrictHttpResponse<number>> {

    const rb = new RequestBuilder(this.rootUrl, TypesDechetsRwService.TypeDechetRwDeletePath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: parseFloat(String((r as HttpResponse<any>).body)) }) as StrictHttpResponse<number>;
      })
    );
  }

  /**
   * Supprime le type de déchets RW spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `typeDechetRwDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  typeDechetRwDelete(params: {

    /**
     * Identifiant du type de déchets RW à supprimer
     */
    id: number;
  }): Observable<number> {

    return this.typeDechetRwDelete$Response(params).pipe(
      map((r: StrictHttpResponse<number>) => r.body as number)
    );
  }

  /**
   * Path part for operation typeDechetRwPost
   */
  static readonly TypeDechetRwPostPath = '/api/types-dechets-rw';

  /**
   * Crée le type de déchets RW.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `typeDechetRwPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  typeDechetRwPost$Response(params: {

    /**
     * Type de déchets RW
     */
    body: TypeDechetRwdto
  }): Observable<StrictHttpResponse<TypeDechetRwdto>> {

    const rb = new RequestBuilder(this.rootUrl, TypesDechetsRwService.TypeDechetRwPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<TypeDechetRwdto>;
      })
    );
  }

  /**
   * Crée le type de déchets RW.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `typeDechetRwPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  typeDechetRwPost(params: {

    /**
     * Type de déchets RW
     */
    body: TypeDechetRwdto
  }): Observable<TypeDechetRwdto> {

    return this.typeDechetRwPost$Response(params).pipe(
      map((r: StrictHttpResponse<TypeDechetRwdto>) => r.body as TypeDechetRwdto)
    );
  }

  /**
   * Path part for operation typeDechetRwDesactivate
   */
  static readonly TypeDechetRwDesactivatePath = '/api/types-dechets-rw/{id}/desactivate';

  /**
   * Désactive le type de déchets RW spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `typeDechetRwDesactivate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  typeDechetRwDesactivate$Response(params: {

    /**
     * Identifiant du type de déchets RW à désactiver
     */
    id: number;

    /**
     * Paramètres de désactivation
     */
    body: TypeDechetRwdto
  }): Observable<StrictHttpResponse<number>> {

    const rb = new RequestBuilder(this.rootUrl, TypesDechetsRwService.TypeDechetRwDesactivatePath, 'put');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: parseFloat(String((r as HttpResponse<any>).body)) }) as StrictHttpResponse<number>;
      })
    );
  }

  /**
   * Désactive le type de déchets RW spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `typeDechetRwDesactivate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  typeDechetRwDesactivate(params: {

    /**
     * Identifiant du type de déchets RW à désactiver
     */
    id: number;

    /**
     * Paramètres de désactivation
     */
    body: TypeDechetRwdto
  }): Observable<number> {

    return this.typeDechetRwDesactivate$Response(params).pipe(
      map((r: StrictHttpResponse<number>) => r.body as number)
    );
  }

}
